/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Box } from "./box";
import { Cylinder } from "./cylinder";
import { GeometryType_Enum, geometryType_EnumFromJSON, geometryType_EnumToJSON } from "./geometry_type";

export const protobufPackage = "structure";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface Geometry {
  geometryType: GeometryType_Enum;
  box: Box | undefined;
  cylinder: Cylinder | undefined;
}

function createBaseGeometry(): Geometry {
  return { geometryType: 0, box: undefined, cylinder: undefined };
}

export const Geometry = {
  encode(message: Geometry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.geometryType !== 0) {
      writer.uint32(24).int32(message.geometryType);
    }
    if (message.box !== undefined) {
      Box.encode(message.box, writer.uint32(10).fork()).ldelim();
    }
    if (message.cylinder !== undefined) {
      Cylinder.encode(message.cylinder, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Geometry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGeometry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3:
          if (tag !== 24) {
            break;
          }

          message.geometryType = reader.int32() as any;
          continue;
        case 1:
          if (tag !== 10) {
            break;
          }

          message.box = Box.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.cylinder = Cylinder.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Geometry {
    return {
      geometryType: isSet(object.geometryType) ? geometryType_EnumFromJSON(object.geometryType) : 0,
      box: isSet(object.box) ? Box.fromJSON(object.box) : undefined,
      cylinder: isSet(object.cylinder) ? Cylinder.fromJSON(object.cylinder) : undefined,
    };
  },

  toJSON(message: Geometry): unknown {
    const obj: any = {};
    if (message.geometryType !== 0) {
      obj.geometryType = geometryType_EnumToJSON(message.geometryType);
    }
    if (message.box !== undefined) {
      obj.box = Box.toJSON(message.box);
    }
    if (message.cylinder !== undefined) {
      obj.cylinder = Cylinder.toJSON(message.cylinder);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Geometry>, I>>(base?: I): Geometry {
    return Geometry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Geometry>, I>>(object: I): Geometry {
    const message = createBaseGeometry();
    message.geometryType = object.geometryType ?? 0;
    message.box = (object.box !== undefined && object.box !== null) ? Box.fromPartial(object.box) : undefined;
    message.cylinder = (object.cylinder !== undefined && object.cylinder !== null)
      ? Cylinder.fromPartial(object.cylinder)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
